module.exports = __webpack_public_path__ + "static/media/burger_menu.9cc9739b.svg";